import * as THREE from "three";
import { SceneManager } from "./SceneManager";
import { FRAME_FRUSTUM_SCALE, CAMERA_NEAR, CAMERA_FAR, CAMERA_OFFSET_DIR } from "../config";

export function frameScene(scene: SceneManager) {
    const { camera, group, renderer, container } = scene;
    const box = new THREE.Box3().setFromObject(group);
    const size = new THREE.Vector3();
    const center = new THREE.Vector3();
    box.getSize(size);
    box.getCenter(center);

    // Frame on horizontal footprint only: taller trees should look taller,
    // not shrink the chunk via auto-zoom.
    const horizDim = Math.max(size.x, size.z);
    const maxDim = horizDim;
    const frustum = horizDim * FRAME_FRUSTUM_SCALE;
    const aspect = container.clientWidth / container.clientHeight;
    const halfH = frustum / 2;
    const halfW = halfH * aspect;

    camera.left = -halfW;
    camera.right = halfW;
    camera.top = halfH;
    camera.bottom = -halfH;
    camera.near = CAMERA_NEAR;
    camera.far = CAMERA_FAR;

    const pos = center
        .clone()
        .add(new THREE.Vector3(...CAMERA_OFFSET_DIR).normalize().multiplyScalar(maxDim));
    camera.position.copy(pos);
    camera.lookAt(center);
    camera.updateProjectionMatrix();

    renderer.setSize(container.clientWidth, container.clientHeight, false);
    renderer.render(scene.scene, camera);
}
